/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamRolePermission,
    IamRolePermissionFromJSON,
    IamRolePermissionFromJSONTyped,
    IamRolePermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface ListIamRolePermissionsResponse
 */
export interface ListIamRolePermissionsResponse {
    /**
     * 
     * @type {Array<IamRolePermission>}
     * @memberof ListIamRolePermissionsResponse
     */
    iamRolePermissions?: Array<IamRolePermission>;
}

export function ListIamRolePermissionsResponseFromJSON(json: any): ListIamRolePermissionsResponse {
    return ListIamRolePermissionsResponseFromJSONTyped(json, false);
}

export function ListIamRolePermissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIamRolePermissionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamRolePermissions': !exists(json, 'iamRolePermissions') ? undefined : ((json['iamRolePermissions'] as Array<any>).map(IamRolePermissionFromJSON)),
    };
}

export function ListIamRolePermissionsResponseToJSON(value?: ListIamRolePermissionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iamRolePermissions': value.iamRolePermissions === undefined ? undefined : ((value.iamRolePermissions as Array<any>).map(IamRolePermissionToJSON)),
    };
}


